/**
 * Email-updates consent maps to the inverse of the wire field.
 *
 * The UI models a positive opt-in (`isAgreeToEmailUpdates`), while the backend
 * persists the negative (`is_opted_out_of_emails`). Keeping the inversion in one
 * place avoids the easy-to-flip footgun of hand-inverting it at each call site.
 */

/** Wire → UI: a user who has NOT opted out is agreeing to email updates. */
export const isAgreeToEmailUpdatesFromWire = (
  isOptedOutOfEmails: boolean | undefined | null
): boolean => !(isOptedOutOfEmails ?? false);

/** UI → wire: agreeing to email updates means NOT opted out. */
export const isOptedOutOfEmailsFromConsent = (
  isAgreeToEmailUpdates: boolean
): boolean => !isAgreeToEmailUpdates;
